import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class InvoiceService {
  private api = inject(ApiService);

  getOne(id: number) { return this.api.get(`/invoice/${id}`); }
  updateAmount(json: any) { return this.api.post('/invoice', json); }
  updateStatus(json: any) { return this.api.post('/invoice/status', json); }
  recalculationAmount(json: any) { return this.api.post('/invoice/update', json); }
}
